// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2z_ZQ","header":"styles_header__2y8oJ"};